<section class="dropdown">
  <button class="btn dropdown-toggle nav-bar__item" type="button" id="infoBarRoutes" data-bs-toggle="dropdown" aria-expanded="false">
    <strong>
      {{ 'shared.header.navigation.about-us' | translate }}
    </strong>
  </button>
  <ul class="dropdown-menu nav-bar__menu" aria-labelledby="infoBarRoutes">
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/organization">
        {{ 'shared.header.navigation.organization' | translate }}
      </a>
    </li>
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/contact">
        {{ 'shared.header.navigation.contact' | translate }}
      </a>
    </li>
    <!-- <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/rules">
        {{ 'shared.header.navigation.rules' | translate }}
        </a>
    </li> -->
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/faq">
        {{ 'shared.header.navigation.faq' | translate }}
      </a>
    </li>
  </ul>
</section>

<section class="dropdown">
  <button class="btn dropdown-toggle nav-bar__item" type="button" id="eventBarRoutes" data-bs-toggle="dropdown" aria-expanded="false">
    <strong>{{ 'shared.header.navigation.event' | translate }}</strong>
  </button>
  <ul class="dropdown-menu nav-bar__menu" aria-labelledby="eventBarRoutes">
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/event/tickets">
        {{ 'shared.header.navigation.tickets' | translate }}
      </a>
    </li>
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/event/hotel">
        {{ 'shared.header.navigation.hotel' | translate }}
      </a>
    </li>
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item disabled-link" disabled routerLink="/event/activities">
        {{ 'shared.header.navigation.activities' | translate }}
      </a>
    </li>
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/event/convention-center">
        {{ 'shared.header.navigation.conventionCenter' | translate }}
      </a>
    </li>
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/event/dealers-den">
        {{ 'shared.header.navigation.dealers-den' | translate }}
      </a>
    </li>
    <li class="nav-bar__menu-container">
      <a class="dropdown-item nav-bar__menu-item" routerLink="/event/artist-alley">
        {{ 'shared.header.navigation.artist-alley' | translate }}
      </a>
    </li>
  </ul>
</section>

<!-- <button class="btn nav-bar__item">
  <a routerLink="/collaborators">{{ 'shared.header.navigation.collaborations' | translate }}</a>
</button> -->

<button routerLink="/volunteer" class="btn nav-bar__item">
  <strong>{{ 'shared.header.navigation.volunteer' | translate }}</strong>
</button>

<button routerLink="/status" class="btn nav-bar__item">
  <strong>
    {{ 'shared.header.navigation.status' | translate }}
  </strong>
</button>
